import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type { AppWaldenViewModel } from '../walden-view';

export default class AppWaldenViewIndexRoute extends Route {
  @service('router') declare routerService: RouterService;

  beforeModel() {
    const parentModel = this.modelFor('app.walden-view') as AppWaldenViewModel;

    if (parentModel?.userCanAccessService && parentModel.pages) {
      this.routerService.transitionTo(
        'app.walden-view.detail',
        parentModel.pages[0]?.routeName,
      );
    }
  }
}
